import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.8601 40.9699C73.8601 40.9699 60.3001 34.0799 56.2501 29.3499C51.7501 24.0899 51.9501 1.44995 51.9501 1.44995H39.5301C39.5301 1.44995 39.8401 24.1999 35.2301 29.3499C30.3401 34.8099 17.6201 40.7699 17.6201 40.7699C23.8101 55.3499 36.2101 59.0699 45.7401 59.0699C55.2701 59.0599 67.6701 55.5499 73.8601 40.9699Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.3904 57.8699C85.8304 45.8599 82.1804 42.6199 77.5104 40.2699C75.2104 39.1099 60.6804 31.3899 60.6804 31.3899C60.6804 31.3899 55.7704 38.3299 46.0904 38.3299C36.4104 38.3299 30.7904 31.3899 30.7904 31.3899C30.7904 31.3899 16.3504 39.0599 13.9504 40.2699C9.28039 42.6199 5.72039 46.2499 4.07039 57.8699C2.59039 68.9299 2.15039 71.6899 2.15039 71.6899H89.3004C89.3104 71.6799 88.7004 68.1599 87.3904 57.8699Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M45.2308 44.7199C35.8708 44.7199 31.0308 40.1799 31.0308 40.1799L15.0508 70.5699H75.5708L59.2608 40.1799C59.2608 40.1799 54.6008 44.7199 45.2308 44.7199Z"
        fill="white"
      />
      <path
        d="M24.8506 34.2C24.8506 34.2 31.1006 44.4399 44.8306 44.4399C60.0206 44.4399 66.6306 34.2 66.6306 34.2"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.7371"
          y1="42.6171"
          x2="45.7371"
          y2="8.58445"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
